<template>
    <empty-table-message v-if="isEmpty" />
    <div v-else class="columns is-multiline">
        <div
            v-for="(pergunta, index) in perguntasRespostas"
            class="column is-6 is-4-fullhd"
            :key="index"
        >
            <ChartViewSelector
                :chartTitle="pergunta.titulo"
                :dataType="pergunta.tipo"
                :chartLabel="pergunta.resposta"
                :chartData="pergunta.respostaCount"
            />
        </div>
    </div>
</template>

<script>
import ChartViewSelector from '@/components/shared/chart/ChartViewSelector.vue';

export default {
    name: 'Graficos',
    components: {
        ChartViewSelector,
    },
    data() {
        return {
            perguntasRespostas: [],
            isEmpty: false,
        };
    },
    created() {
        this.carregarDados();
    },
    props: {
        filters: {
            type: Object,
            default: () => {},
        },
    },
    watch: {
        filters: {
            handler() {
                this.carregarDados();
            },
            deep: true,
        },
    },
    methods: {
        carregarDados() {
            this.$emit('updateIsLoading', true);
            this.perguntasRespostas = [];

            this.$axios
                .post(`${this.$route.meta.abrev}/formPergunta.json`, this.filters, {
                    params: {
                        idFormulario: +this.$route.params.idFormulario,
                        origem: this.$route.query.origem,
                    },
                })
                .then((response) => {
                    this.isEmpty = response.data.content.length === 0;
                    this.perguntasRespostas = this.mapPerguntasRespostasToChart(
                        response.data.content
                    );
                })
                .catch((_) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.$emit('updateIsLoading', false);
                });
        },
        mapPerguntasRespostasToChart(perguntasRespostas) {
            return perguntasRespostas.map((perguntaResposta) => {
                const titulo = perguntaResposta.descricao;

                const tipo = perguntaResposta.item_tipo;

                const resposta = perguntaResposta.formRespostaPreenchidaList.map(
                    (resposta) => resposta.resposta
                );

                const respostaCount = perguntaResposta.formRespostaPreenchidaList.map(
                    (resposta) => resposta.respostaCount
                );

                return {
                    titulo,
                    tipo,
                    resposta,
                    respostaCount,
                };
            });
        },
    },
};
</script>
